import Icon from '../icon/Icon';

interface EmptyScreenProps {
  iconName?: string;
  imageSrc?: string;
  imageAlt?: string;
  imageClassName?: string;
  heading: string;
  children?: React.ReactNode;
  className?: string;
  headingStyle?: string;
}

const EmptyScreen = ({
  iconName,
  imageSrc,
  imageAlt = '',
  heading,
  children,
  className,
  headingStyle,
  imageClassName
}: EmptyScreenProps) => (
  <div
    className={`flex w-full flex-col items-center justify-center ${className}`}
  >
    {imageSrc ? (
      <img
        src={imageSrc}
        alt={imageAlt}
        className={imageClassName || 'size-16 object-contain'}
      />
    ) : (
      !!iconName && (
        <div className="flex size-16 items-center justify-center rounded-2xl bg-primary1">
          <Icon name={iconName} size="24" />
        </div>
      )
    )}

    <div className="mt-6 text-center">
      <p className={`text-lg font-semibold leading-6 ${headingStyle}`}>
        {heading}
      </p>
      {children}
    </div>
  </div>
);

export default EmptyScreen;
